import {h, Fragment} from "preact"
import { SerpElement } from '@nosto/preact'
import { useEffect, useMemo, useState } from 'preact/hooks';
import { formatCurrency, getProductByHandle } from '../helpers'
import { isFrench } from '../config'

export default ({ product }) => {
    const [ hoverImg, setHoverImg ] = useState(null);
    const [ scents, setScents ] = useState(null);
    const [ badge, setBadge ] = useState(null);
    const [ award, setAward ] = useState(null);
    const [ isKit, setIsKit ] = useState(false);
    const handle = product.url.split('/products/')[1];
    const forcePdpAtc = !!(product.customFields?.find(field => field.key === "custom-force_pdp_atc" && field.value === "true"))
    const isVoyages = useMemo(() => product.tags1?.includes('Voyages'), [])

    const addToCart = (e) => {
        e.preventDefault();
        window.globalAddToCart({ handle, variantId: product.skus[0].id })
    }

    useEffect(() => {
        getProductByHandle(handle)
            .then(res => {
                const responseImage = res.data?.productByHandle?.productCardHoverImage?.reference?.image?.url;
                setHoverImg(responseImage);
                
                const awardsObj = res.data?.productByHandle?.awardBadge?.reference?.fields?.find(field => !!field?.reference)?.reference?.image;
                setAward(awardsObj)

                const responseBadge = res.data?.productByHandle?.standardBadge?.reference?.fields?.reduce((obj, field) => {
                    obj[field.key] = field.value;
                    return obj;
                }, {})
                setBadge(responseBadge);
                
                const responseScents = res.data?.productByHandle?.scentColors?.references?.edges?.map(scent => {
                    const hex = scent.node.fields.find(field => field.key === 'color').value;
                    const color = scent.node.fields.find(field => field.key === 'color_text').value;
                    return { hex, color };
                });
                setScents(responseScents);

                // console.log("nosto check", res.data?.productByHandle)

                setIsKit((res.data?.productByHandle?.kitOptionGroup1?.references?.nodes?.length > 0))
            })
    }, []);
    
    return (
        <SerpElement as="div" hit={product} class={`relative col-span-1 bg-cream-grey group ${isVoyages? 'ns-voyages' : ''}`} data-product-card="true">
            {/* Desktop Hover Details */}
            <div class="hidden laptop:group-hover:block">
                <a href={product.url} class="h-full relative block link-unstyled pt-[80%] !h-0">
                    {hoverImg
                        ?   <img class="image block w-full absolute top-0 left-0 h-full object-cover" srcset={`${hoverImg.replace('.jpg', '_326x.jpg')} 326w, ${hoverImg.replace('.jpg', '_650x.jpg')} 650w`} sizes="(max-width: 640px) 326px, 650px" src={hoverImg} alt={product.name} loading="lazy" />
                        :   product.alternateImageUrls && product.alternateImageUrls.length > 0
                            ?   <img class="image block w-full absolute top-0 left-0 h-full object-cover" srcset={`${product.alternateImageUrls[0]?.replace('.jpg', '_326x.jpg')} 326w, ${product.alternateImageUrls[0]?.replace('.jpg', '_650x.jpg')} 650w`} sizes="(max-width: 640px) 326px, 650px" src={product.alternateImageUrls[0]} alt={product.name} loading="lazy" />
                            :   <img class="image block w-full absolute top-0 left-0 h-full object-cover" srcset={`${product.imageUrl?.replace('.jpg', '_326x.jpg')} 326w, ${product.imageUrl?.replace('.jpg', '_650x.jpg')} 650w`} sizes="(max-width: 640px) 326px, 650px" src={product.imageUrl} alt={product.name} loading="lazy" />
                    }
                    <div class="absolute bottom-2.5 left-2.5 max-w-[calc(100%-20px)] w-full z-[5]">
                        <div class="flex items-center justify-start gap-[7.8px]">
                            {product.availability === 'OutOfStock'
                                ?   <button type="submit" class="btn-primary cta-large py-[14.5px] w-full transition-all hover:!border-charcoal hover:bg-charcoal hover:!text-white flex items-center justify-between" disabled>
                                        <span>{isFrench ? 'En Rupture de Stock' : 'Out of Stock'}</span>
                                        {product.price != 0 &&
                                        <div class="justify-start flex gap-2.5">
                                            <span class="cta-large">{formatCurrency(product.price)}</span>
                                            {product.listPrice && product.listPrice > product.price && <del class="cta-large text-white">{formatCurrency(product.listPrice)}</del>}
                                        </div>
                                        }
                                    </button>
                                : forcePdpAtc
                                    ?   <a href={product.url} class="prod-link btn-primary cta-large py-[14.5px] w-full transition-all hover:!border-charcoal hover:bg-charcoal hover:!text-white flex items-center justify-between">
                                            <span>{isFrench ? "Voir le produit" : "Select Your Products"}</span>
                                        </a>
                                    :   isKit
                                        ?   <a href={product.url} class="hover:no-bg btn-primary cta-large py-[14.5px] w-full transition-all hover:!border-charcoal hover:bg-charcoal hover:!text-white flex items-center justify-between">
                                                <span>{isFrench ? 'Sélectionner les produits' : 'Select Your Products'}</span>
                                            </a>
                                        :   <button 
                                                type="submit" 
                                                aria-label={`Add ${product.name} to cart`}
                                                class="btn-primary cta-large py-[14.5px] w-full transition-all hover:!border-charcoal hover:bg-charcoal hover:!text-white flex items-center justify-between" 
                                                onClick={addToCart}
                                            >
                                                <span>{isFrench ? 'Ajouter au panier' : 'Add to Bag'}</span>
                                                {product.price != 0 &&
                                                <div class="justify-start flex gap-2.5">
                                                    <span class="cta-large">{formatCurrency(product.price)}</span>
                                                    {product.listPrice && product.listPrice > product.price && <del class="cta-large text-white">{formatCurrency(product.listPrice)}</del>}
                                                </div>
                                                }
                                            </button>
                            }
                        </div>
                    </div>
                </a>
            </div>
            {/* Main Product Details */}
            <div class="block prod-details">
                <a href={product.url} class="h-0 relative pt-[80%] block link-unstyled laptop:group-hover:hidden">
                    {(badge || award) &&
                        <div class={`flex ${award && !badge ? 'justify-end' : 'justify-between'} absolute z-[3] top-[5px] laptop:top-2.5 laptop:left-2.5 left-[5px] items-start laptop:w-[calc(100%-20px)] w-[calc(100%-10px)] laptop:group-hover:hidden`}>
                            {badge && <p class="text-black bg-white laptop:px-2.5 px-2 py-[5px] laptop:py-2 font-badge-card" style={`background-color: ${badge['background_color']}; color: ${badge['text_color']};`}>{badge['badge_text']}</p>}
                            {award && <img class="prod-award" src={award.url} alt={award.altText} />}
                        </div>
                    }
                    <img 
                        class={`image block w-full absolute top-0 left-0 h-full object-cover z-[2] ${(product.imageUrl?.includes('white-background') || product.imageUrl?.includes('white_background')) ? 'mix-blend-multiply' : ''}`} 
                        srcset={`${product.imageUrl?.replace('.jpg', '_326x.jpg')} 326w, ${product.imageUrl?.replace('.jpg', '_650x.jpg')} 650w`} 
                        sizes="(max-width: 640px) 326px, 650px" 
                        src={product.imageUrl} 
                        alt={product.name} 
                        loading="lazy"
                    />
                    {(product.availability === 'InStock' && !forcePdpAtc && !isKit) && (
                        <div class="absolute bottom-[5px] right-[5px] z-[5]">
                            <div class="flex items-center justify-start gap-[7.8px]">
                                <button
                                    type="submit"
                                    aria-label={`Add ${product.name} to cart`}
                                    class="block laptop:hidden rounded-full border w-[25px] h-[25px] flex items-center justify-center !p-0 border-black/30 cta-large py-[14.5px] w-full transition-all hover:!border-charcoal hover:bg-charcoal hover:!text-white"
                                    onClick={addToCart}
                                >
                                    <span class="hidden laptop:block">Add to bag</span>
                                    <span class="laptop:hidden">
                                        <svg width="13" height="12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.257 6h10M6.257 1v10" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"></path></svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                    )}
                </a>
                <div class="ns-prod-footer flex flex-col p-3 pt-0">
                    {!isVoyages &&
                        <div class="flex items-center justify-start gap-[2.35px] mb-3 pt-3 border-t border-black-30">
                            <div class="yotpo bottomLine yotpo-small" data-product-id={product.productId} />
                        </div>
                    }
                    {scents && 
                        <div class="flex items-center justify-start gap-[14px] mb-2">
                            {scents.map((s) => (<div class="flex items-center justify-start gap-[6px]">
                                <span class="w-2 h-2 rounded-[50px] inline-block" style={`background-color: ${s.hex};`}></span>
                                <span class="utility-1 text-charcoal capitalize tracking-[1px]">{s.color}</span>
                            </div>)
                            )}
                        </div>
                    }
                    <div class="mb-2">
                        <a href={product.url} class="text-black font-14">{product.name}</a>
                    </div>
                    {product.price != 0 &&
                    <div class="justify-start flex gap-2.5">
                        <span class="font-13 text-charcoal">{formatCurrency(product.price)}</span>
                        {product.listPrice && product.listPrice > product.price && <del class="font-13 text-grey-60">{formatCurrency(product.listPrice)}</del>}
                    </div>}
                </div>
            </div>
        </SerpElement>
    )
}
